export default "__VITE_ASSET__COzMvogV__"